module.exports = __webpack_public_path__ + "img/ebcd782.jpg";